export const DEFAULT_NAME = "No name";

export const COMPANY_NAME = "SPICE";
